import {cn, Skeleton} from '@chekinapp/ui';
import styles from '@chekin/shared/guest-form/arrival.module.css';

type Props = {
  wide?: boolean;
  className?: string;
};

function ArrivalSkeleton({wide, className}: Props) {
  const heroLines = (
    <>
      <Skeleton onScene className="h-[25px] w-[150px] rounded-full" />
      <Skeleton onScene className="h-8 w-[68%] rounded-[10px]" />
      <Skeleton onScene className="h-4 w-[46%]" />
    </>
  );

  return (
    <div
      aria-busy
      className={cn(
        'flex min-h-[var(--app-dvh,100dvh)] w-full flex-col bg-[var(--background-main)] desk:flex-row',
        className,
      )}
    >
      <aside className="relative hidden w-[38%] min-w-[380px] shrink-0 flex-col overflow-hidden desk:flex">
        <div className={cn('absolute inset-0', styles.skeleton)} />
        <div className="relative z-[2] mt-auto flex flex-col gap-3 px-[34px] pb-[30px]">
          {heroLines}
        </div>
      </aside>

      <div className="relative flex min-h-[268px] shrink-0 flex-col overflow-hidden desk:hidden">
        <div className={cn('absolute inset-0', styles.skeleton)} />
        <div className="relative z-[2] mt-auto flex flex-col gap-2.5 px-[18px] pb-11">
          {heroLines}
        </div>
      </div>

      <main
        className={cn(
          styles.panel,
          'relative z-[3] flex min-w-0 flex-1 flex-col overflow-hidden',
          '-mt-[34px] px-3.5 pb-0 desk:mt-0 desk:items-center desk:justify-center desk:p-[34px]',
        )}
      >
        <div
          className={cn(
            'relative z-[1] w-full',
            wide ? 'desk:max-w-[560px]' : 'desk:max-w-[420px]',
          )}
        >
          <div className="w-full rounded-[24px] bg-white p-4 pt-[18px] desk:px-[26px] desk:pb-[22px] desk:pt-[26px]">
            <Skeleton className="h-6 w-[62%] rounded-[9px]" />
            <Skeleton className="mt-2.5 h-3.5 w-full" />
            <Skeleton className="mt-1.5 h-3.5 w-[80%]" />
            <Skeleton className="mt-5 h-[62px] w-full rounded-[14px]" />
            <Skeleton className="mt-2.5 h-[52px] w-full rounded-[14px]" />
            <Skeleton className="mt-2.5 h-[52px] w-full rounded-[14px]" />
            <Skeleton className="mt-[18px] h-12 w-full rounded-xl" />
          </div>
        </div>
      </main>
    </div>
  );
}

export {ArrivalSkeleton};
